import {createSlice, PayloadAction} from '@reduxjs/toolkit'
import type {RootState} from '../app/store'
import { AppFirebaseState } from '../app/types/AppFirebaseState';
import { AppUsersType, } from '../app/types/AppUserType';
import { MaybeString } from '../app/types/Maybe';

const initialState: AppFirebaseState<AppUsersType> = {
    data: [], loading: false
}

function customSort(a: string, b: string) {
    return a.localeCompare(b, 'en', { sensitivity: 'base' });
}

export const appAuthSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        setUsers: (state, action: PayloadAction<AppUsersType>) => {
            state.data = action.payload.sort((a, b) => {
                if (/[\u0400-\u04FF]/.test(a.name) && !/[\u0400-\u04FF]/.test(b.name)) {
                    return -1; // Place Cyrillic strings before non-Cyrillic ones
                } else if (!/[\u0400-\u04FF]/.test(a.name) && /[\u0400-\u04FF]/.test(b.name)) {
                    return 1; // Place non-Cyrillic strings after Cyrillic ones
                } else {
                    return customSort(a.name, b.name); // Sort alphabetically within the same script
                }
            });
        },
        setUsersLoading: (state, action: PayloadAction<boolean>) => {
            state.loading = action.payload;
        },
        setUsersError: (state, action: PayloadAction<MaybeString>) => {
            state.error = action.payload;
        },
    },
})

export const {setUsers, setUsersLoading, setUsersError} = appAuthSlice.actions

// Other code such as selectors can use the imported `RootState` type
export const selectUsers = (state: RootState) => state.auth.data;
export const selectUsersLoading = (state: RootState) => state.auth.loading;
export const selectUsersError = (state: RootState) => state.auth.error;

export const AppAuthReducer = appAuthSlice.reducer;
